import { call, put } from '@redux-saga/core/effects'
import { api } from 'application/api'
import { populateFormMetaData } from 'application/redux/actions/form'
import { accessTokenForm } from 'application/storage/access_token'

export function* getPublicFileInfo(action) {
    const responsePublicFileInfo = yield call(api.gateway.files.getPublicFileInfo, action.accountId, accessTokenForm)
    yield put(populateFormMetaData({ publicFileInfo: responsePublicFileInfo }))
}